import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { SideNav } from './components/SideNav/SideNav';
import { useAuth } from './hooks';

const Layout = styled('div')`
  position: fixed;
  height: 100vh;
  width: 100%;

  display: grid;

  grid-template-areas: 'side-nav content';

  grid-template-rows: 1fr;

  grid-template-columns: min-content auto;

  min-height: 0;
`;

export const AppLayout = ({ children }: PropsWithChildren) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <Layout data-test={'app-layout'}>
      <SideNav />

      {children}
    </Layout>
  ) : (
    <div>{children}</div>
  );
};
